export function getStatusType(
  status: string,
  type: string,
  resume = true
): string {
  let statusResponse = '';
  if (type === 'assistancie') {
    switch (status) {
      case 'APROVADO':
      case 'EMAND':
      case 'PAUSADA':
      case 'AGADEQ':
      case 'AGMAT':
      case 'ADIADO':
        statusResponse = resume ? 'Em atendimento' : 'OS em atendimento';
        break;
      case 'COMP':
      case 'FECHAR':
      case 'CONFERIDO':
        statusResponse = resume ? 'Finalizada' : 'OS finalizada';
        break;
      case 'CANCEL':
      case 'SEMEXEC':
        statusResponse = resume ? 'Cancelada' : 'OS cancelada';
        break;
      case 'AGPLAN':
      case 'AAPRV':
      case 'APROG':
      case 'OSGER':
        statusResponse = resume ? 'Em analise' : 'OS em analise';
        break;
      default:
        statusResponse = resume ? 'Em analise' : 'OS em analise';
        break;
    }
  } else {
    switch (status) {
      case 'PEDAGE':
      case 'AGEREA':
        statusResponse = resume ? 'Agendado' : 'Pedido agendado';
        break;
      case 'SNOREC':
      case 'CANREA':
      case 'ERRO':
      case 'CANCELADO':
        statusResponse = resume ? 'Cancelado' : 'Pedido cancelado';
        break;
      case 'AGUCONLOG':
      case 'AGUTRA':
      case 'AGUANA':
      case 'GERPEDAUT':
      case 'RENDATCLI':
      case 'GREOSAUT':
      case 'ERRINT':
      case 'CANEA':
        statusResponse = resume ? 'Em analise' : 'Pedido em analise';
        break;
      case 'AGENDADO':
        statusResponse = resume ? 'Agendado' : 'Pedido agendado';
        break;
      case 'REPROGRAMADO':
        statusResponse = resume ? 'Reprogramado' : 'Pedido reprogramado';
        break;
      case 'PEDIDO_EM_ANALISE':
        statusResponse = resume ? 'Em analise' : 'Pedido em analise';
        break;
      case 'CONFIRMADO':
        statusResponse = resume ? 'Confirmado' : 'Pedido confirmado';
        break;
      case 'EM_ROTA':
        statusResponse = resume ? 'Em rota' : 'Pedido em rota';
        break;
      case 'NAO_ATENDIDO':
        statusResponse = resume ? 'Não atendido' : 'Pedido não atendido';
        break;
      case 'ATENDIDO':
        statusResponse = resume ? 'Atendido' : 'Pedido atendido';
        break;
      case 'NAO_IDENTIFICADO':
        statusResponse = resume
          ? 'Não identificado'
          : 'Pedido não identificado';
        break;
      case 'RECEBIDO':
        statusResponse = resume ? 'Recebido' : 'Pedido recebido';
        break;
      default:
        statusResponse = resume ? 'Em analise' : 'Pedido em analise';
        break;
    }
  }

  return statusResponse;
}

export function getStatusColor(status: string, type: string): string {
  let statusResponse = '';
  if (type === 'assistancie') {
    switch (status) {
      case 'APROVADO':
      case 'EMAND':
      case 'PAUSADA':
      case 'AGADEQ':
      case 'AGMAT':
      case 'ADIADO':
      case 'AGPLAN':
      case 'AAPRV':
      case 'APROG':
        statusResponse = '#F8C953';
        break;
      case 'COMP':
      case 'FECHAR':
      case 'CONFERIDO':
        statusResponse = '#40BC61';
        break;
      case 'CANCEL':
      case 'SEMEXEC':
        statusResponse = '#EC4D2C';
        break;
      default:
        statusResponse = '#F8C953';
        break;
    }
  } else {
    switch (status) {
      case 'AGUCONLOG':
      case 'AGUANA':
      case 'GERPEDAUT':
      case 'RENDATCLI':
      case 'GREOSAUT':
      case 'ERRINT':
      case 'CANEA':
      case 'PEDIDO_EM_ANALISE':
      case 'REPROGRAMADO':
      case 'AGENDADO':
        statusResponse = '#FEF7EA';
        break;
      case 'CONFIRMADO':
      case 'EM_ROTA':
        statusResponse = '#E6EFFC';
        break;
      case 'PEDAGE':
      case 'AGEREA':
      case 'ATENDIDO':
        statusResponse = '#EAF7EE';
        break;
      case 'SNOREC':
      case 'CANREA':
      case 'ERRO':
      case 'NAO_ATENDIDO':
      case 'CANCELADO':
      case 'NAO_IDENTIFICADO':
        statusResponse = '#FCEDE9';
        break;
      default:
        statusResponse = '#FEF7EA';
        break;
    }
  }
  return statusResponse;
}

export function getStatusTextColor(status: string, type: string): string {
  let statusResponse = '';
  if (type === 'assistancie') {
    switch (status) {
      case 'APROVADO':
      case 'EMAND':
      case 'PAUSADA':
      case 'AGADEQ':
      case 'AGMAT':
      case 'ADIADO':
      case 'AGPLAN':
      case 'AAPRV':
      case 'APROG':
        statusResponse = '#ED9500';
        break;
      case 'COMP':
      case 'FECHAR':
      case 'CONFERIDO':
        statusResponse = '#EAF7EE';
        break;
      case 'CANCEL':
      case 'SEMEXEC':
        statusResponse = '#FCEDE9';
        break;
      default:
        statusResponse = '#ED9500';
        break;
    }
  } else {
    switch (status) {
      case 'AGUCONLOG':
      case 'AGUANA':
      case 'GERPEDAUT':
      case 'RENDATCLI':
      case 'GREOSAUT':
      case 'ERRINT':
      case 'CANEA':
      case 'PEDIDO_EM_ANALISE':
      case 'REPROGRAMADO':
      case 'AGENDADO':
        statusResponse = '#F8C953';
        break;
      case 'CONFIRMADO':
      case 'EM_ROTA':
        statusResponse = '#036BE1';
        break;
      case 'PEDAGE':
      case 'AGEREA':
      case 'ATENDIDO':
        statusResponse = '#40BC61';
        break;
      case 'SNOREC':
      case 'CANREA':
      case 'ERRO':
      case 'NAO_ATENDIDO':
      case 'CANCELADO':
      case 'NAO_IDENTIFICADO':
        statusResponse = '#EC4D2C';
        break;
      default:
        statusResponse = '#F8C953';
        break;
    }
  }
  return statusResponse;
}
